export default "__VITE_ASSET__CBf6Z9$9__"